import { SelectItem } from 'primeng/api';

export enum DivisionType {
  PARK = 'PARK',
  EEI = 'EEI',
}

export const DIVISION_TYPE = [
  { label: 'Park (default)', value: DivisionType.PARK },
  { label: 'EEI', value: DivisionType.EEI },
] as SelectItem[];
